// extracted by mini-css-extract-plugin
module.exports = {"wrapHeader":"Header_wrapHeader__1SEX4","dot":"Header_dot__1qE29","pulse":"Header_pulse__fmTLk"};